'use strict';

export default class HotelSortPropertiesCalculator {

    constructor() {
        this.sectorListPoints = [];
    }

    getCheapestDistributionPrice(hotel) {
        if ('cheapestDistributionPrice' in hotel) {
            return hotel.cheapestDistributionPrice;
        }

        let cheapestDistributionPrice = Number.MAX_SAFE_INTEGER;

        for (let mealPlan of hotel.meal_plans) {
            for (let pista of mealPlan.pistas) {
                for (let roomDistribution of pista.room_distributions) {
                    let distributionPrice = roomDistribution.filter_person_price;
                    if (distributionPrice < cheapestDistributionPrice) {
                        cheapestDistributionPrice = distributionPrice;
                    }
                }
            }
        }

        hotel.cheapestDistributionPrice = cheapestDistributionPrice;

        return cheapestDistributionPrice;
    }

    getFirstDistributionPrice(hotel) {
        let cheapestDistributionPrice = Number.MAX_SAFE_INTEGER;

        for (let mealPlan of hotel.meal_plans) {
            for (let roomDistribution of mealPlan.pistas[0].room_distributions) {
                let distributionPrice = roomDistribution.filter_person_price;
                if (distributionPrice < cheapestDistributionPrice) {
                    cheapestDistributionPrice = distributionPrice;
                }
            }
        }

        return cheapestDistributionPrice;
    }

    getSelectedMealPlan(hotel) {
        if (!hotel.meal_plans) {
            return null;
        }
        for (let mealPlan of hotel.meal_plans) {
            if (mealPlan.is_selected) {
                return mealPlan;
            }
        }

        return hotel.meal_plans[0];
    }

    getCheapestVisibleDistributionPrice(hotel, first = false) {
        let cheapestDistributionPrice = Number.MAX_SAFE_INTEGER;

        for (let mealPlan of hotel.meal_plans) {
            if (!mealPlan.is_selected) {
                continue;
            }
            for (let pista of mealPlan.pistas) {
                if (pista.hidden) {
                    continue;
                }
                for (let roomDistribution of pista.room_distributions) {
                    let distributionPrice = roomDistribution.filter_person_price;
                    if (distributionPrice < cheapestDistributionPrice) {
                        if (first) return distributionPrice;
                        cheapestDistributionPrice = distributionPrice;
                    }
                }
            }
        }
        hotel.cheapestVisibleDistributionPrice = cheapestDistributionPrice;

        return cheapestDistributionPrice;
    }

    getRateValue(hotel) {
        return hotel.rate;
    }

    getHasService(hotel, icon) {
        let result = null;
        const getService = (services) => {
            for (let service of services) {
                if (!service.hasOwnProperty('icon')) {
                    continue;
                }

                if (service.icon == icon) {
                    return icon;
                }
            }
        };

        if (hotel.hasOwnProperty('services')) {
            result = getService(hotel.services);

            if (result) {
                return result;
            }
        }

        return false;
    }

    getCondition(hotel, condition) {
        if (hotel.hasOwnProperty('snow_warranty_text')) {
            if (hotel.snow_warranty_text == condition) {
                return condition;
            }
        }

        if (hotel.hasOwnProperty('covid_guarantee_text')) {
            if (hotel.covid_guarantee_text == condition) {
                return condition;
            }
        }

        return false;
    }

    getId(hotel) {
        return hotel.id;
    }

    getFilterCategoryValue(hotel) {
        if ('filterCategoryValue' in hotel) {
            return hotel.filterCategoryValue;
        }

        let filterCategoryValue = 0.5;

        if (hotel.stars) {
            filterCategoryValue = hotel.stars;
        }

        hotel.filterCategoryValue = filterCategoryValue;
        return filterCategoryValue;
    }

    getCategoryValue(hotel) {
        if ('categoryValue' in hotel) {
            return hotel.categoryValue;
        }

        let categoryValue = 0;

        if (hotel.superior) {
            categoryValue += .5;
        }

        if (hotel.stars) {
            categoryValue += hotel.stars;
            hotel.categoryValue = categoryValue;
            return categoryValue;
        }

        if (hotel.keys) {
            switch (hotel.keys) {
                case 1:
                    categoryValue += 0.5;
                    break;
                case 2:
                    categoryValue += 2.5;
                    break;
                case 3:
                    categoryValue += 3.9;
                    break;
            }
        }

        hotel.categoryValue = categoryValue;

        return categoryValue;
    }

    getHotelTypeValue(hotel) {
        return hotel.hotel_type_id;
    }

    getNearestPistaDistance(hotel, pistaId) {
        if ('nearestPistaDistance' in hotel) {
            return hotel.nearestPistaDistance;
        }

        let nearestPistaDistance = Number.MAX_SAFE_INTEGER;

        for (let mealPlan of hotel.meal_plans) {
            for (let pista of mealPlan.pistas) {
                if ((pistaId > 0) && (pista.id != pistaId)) {
                    continue;
                }

                let pistaDistance = pista.distance_value;
                if (pistaDistance < nearestPistaDistance) {
                    nearestPistaDistance = pistaDistance;
                }
            }
        }

        hotel.nearestPistaDistance = nearestPistaDistance;

        return nearestPistaDistance;
    }

    getNearestVisiblePistaDistance(hotel, pistaId) {
        let nearestPistaDistance = Number.MAX_SAFE_INTEGER;
        for (let mealPlan of hotel.meal_plans) {
            if (!mealPlan.is_selected) {
                continue;
            }
            for (let pista of mealPlan.pistas) {
                if (pista.hidden || ((pistaId > 0) && (pista.id != pistaId))) {
                    continue;
                }
                let pistaDistance = pista.distance_value;
                if (pistaDistance < nearestPistaDistance) {
                    nearestPistaDistance = pistaDistance;
                }
            }
        }

        return nearestPistaDistance;
    }


    getHasMealPlan(hotel, mealPlanId) {
        for (let mealPlan of hotel.meal_plans) {
            if (mealPlan.id == mealPlanId) {
                return mealPlanId;
            }
        }
        return false;
    }

    getSector(hotel, sectorName) {
        if ('sectors' in hotel) {
            return hotel.sectors.includes(sectorName) ? sectorName : false;
        }

        if (this.sectorListPoints.length === 0) {
            this.sectorListPoints = this.getSectorList();
        }

        let hotelGoogleMapsLatLng = {
            lat: hotel.latitude,
            lng: hotel.longitude
        };

        let containsLocation;

        hotel.sectors = [];
        for (let sector of this.sectorListPoints) {
            try {
                containsLocation = this.isPointInPolygon(hotelGoogleMapsLatLng, sector.points);
                if (containsLocation) {
                    hotel.sectors.push(sector.name);
                }
            } catch (e) {
            }
        }
        return hotel.sectors.includes(sectorName) ? sectorName : false;
    }

    isPointInPolygon(point, polygon) {
        const {lat, lng} = point;
        let isInside = false;

        for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            const xi = polygon[i].lat, yi = polygon[i].lng;
            const xj = polygon[j].lat, yj = polygon[j].lng;

            const intersect = ((yi > lng) !== (yj > lng)) &&
                (lat < (xj - xi) * (lng - yi) / (yj - yi) + xi);
            if (intersect) isInside = !isInside;
        }

        return isInside;
    }

    getPriorityValue(hotel) {
        return hotel.highlighted_hotel ? Number.MAX_SAFE_INTEGER : hotel.priority || 0;
    }

    getSectorList() {
        return [
            {
                name: "peretol",
                points: [
                    {lat: 42.5743384711305, lng: 1.6796547656306486},
                    {lat: 42.558328451378244, lng: 1.701150915638103},
                    {lat: 42.549623692641084, lng: 1.683123187435138},
                    {lat: 42.56866563167558, lng: 1.66505512909681}
                ]
            },
            {
                name: "massana",
                points:
                    [
                        {lat: 42.551761, lng: 1.505732},
                        {lat: 42.551708, lng: 1.528101},
                        {lat: 42.538727, lng: 1.526931},
                        {lat: 42.537366, lng: 1.508397}
                    ]

            },
            {
                name: "encamp",
                points:
                    [
                        {lat: 42.55260371163576, lng: 1.605353869740303},
                        {lat: 42.52330309450321, lng: 1.5970617632860973},
                        {lat: 42.526380974358844, lng: 1.5523328106021963},
                        {lat: 42.55461009983665, lng: 1.5643775489678506}
                    ]

            },
            {
                name: "canillo",
                points:
                    [
                        {lat: 42.55413965995818, lng: 1.578355661122009},
                        {lat: 42.582465034527594, lng: 1.5876084236653316},
                        {lat: 42.5737858102443, lng: 1.6350393670034893},
                        {lat: 42.55140247871174, lng: 1.6151581332689322}
                    ]

            },
            {
                name: "soldeu",
                points:
                    [
                        {lat: 42.60925895509061, lng: 1.6595722790634173},
                        {lat: 42.57558928545055, lng: 1.657474676368953},
                        {lat: 42.57314675785745, lng: 1.6711183557793614},
                        {lat: 42.604428339512175, lng: 1.6973163445490909}
                    ]

            },
            {
                name: "tarter",
                points:
                    [
                        {lat: 42.57521167686383, lng: 1.624014030568926},
                        {lat: 42.59335145482473, lng: 1.6190486077401847},
                        {lat: 42.584137744356866, lng: 1.6620330537531325},
                        {lat: 42.57371828440817, lng: 1.6615550286460392}
                    ]

            },
            {
                name: "graupascasa",
                points:
                    [
                        {lat: 42.55081, lng: 1.69155},
                        {lat: 42.529, lng: 1.69247},
                        {lat: 42.52802, lng: 1.73697},
                        {lat: 42.54991, lng: 1.73728}
                    ]

            },
            {
                name: "palarinsal",
                points:
                    [
                        {lat: 42.516507409089584, lng: 1.4821388996782077},
                        {lat: 42.53424054555431, lng: 1.5438666398018548},
                        {lat: 42.58677806552679, lng: 1.4905792181487376},
                        {lat: 42.57697, lng: 1.45792}
                    ]

            },
            {
                name: "ordinoarcalis",
                points:
                    [
                        {lat: 42.549663556862136, lng: 1.5077321510649946},
                        {lat: 42.552135460357704, lng: 1.5470326175623672},
                        {lat: 42.63998, lng: 1.55829},
                        {lat: 42.63048, lng: 1.50924}
                    ]

            },
            {
                name: "centreandorraescaldes",
                points:
                    [
                        {lat: 42.491403335730574, lng: 1.556674018294399},
                        {lat: 42.49200262174269, lng: 1.475617548018332},
                        {lat: 42.51974605387215, lng: 1.49351094205113},
                        {lat: 42.51688192580651, lng: 1.558380237059975}
                    ]

            },
            {
                name: "santjulia",
                points:
                    [
                        {lat: 42.492493465781834, lng: 1.44815717686304},
                        {lat: 42.48802767361447, lng: 1.5379154386185094},
                        {lat: 42.433145737319215, lng: 1.5151369069568983},
                        {lat: 42.4415511938322, lng: 1.4468917028805863}
                    ]

            },
        ]
    }

    getCityValue(hotel) {
        return hotel.city_id;
    }
}
